export default function checkNumber(x) {
    if(typeof x == 'number' && !isNaN(x)){
        if (Number.isInteger(x)) {
            return true
        }
        else {
            return false
        }
    } return "Not number"
}